import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Badge,
  Modal
} from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BsCopy } from 'react-icons/bs';
import { getCommit, updateCommit } from '../../actions/commitAction';
import CommitEditModal from './CommitEditModal';
import DocListModal from './DocListModal';
import DocListAllModal from './DocListAllModal';

class CommitView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editModal: false,
      mainDocsModal: false,
      subDocsModal: false,
      mainDocsAllModal: false,
      subDocsAllModal: false,
      mainDocs: [],
      subDocs: []
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    this.props.getCommit(id);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.commit !== this.props.commit) {
      const { commit } = this.props;
      if (commit) {
        const { main_docs, sub_docs } = commit;
        this.setState({
          mainDocs: main_docs,
          subDocs: sub_docs
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.commit !== this.props.commit) {
      this.setState({ commit: nextProps.commit });
    }
  }

  toggleEditModal = () => {
    this.setState(prevState => ({
      editModal: !prevState.editModal
    }));
  };

  toggleMainDocsModal = () => {
    this.setState(prevState => ({
      mainDocsModal: !prevState.mainDocsModal
    }));
  };

  toggleSubDocsModal = () => {
    this.setState(prevState => ({
      subDocsModal: !prevState.subDocsModal
    }));
  };

  toggleMainDocsAllModal = () => {
    this.setState(prevState => ({
      mainDocsAllModal: !prevState.mainDocsAllModal
    }));
  };

  toggleSubDocsAllModal = () => {
    this.setState(prevState => ({
      subDocsAllModal: !prevState.subDocsAllModal
    }));
  };

  handleEditSubmit = (commitData) => {
    const { id } = this.props.match.params;
    this.props.updateCommit(id, commitData);
  };

  handleCopy = (text, fieldName) => {
    navigator.clipboard.writeText(text);
    toast.success(`${fieldName} copied to clipboard!`, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  render() {
    const { 
      commit, 
      editModal, 
      mainDocsModal, 
      subDocsModal, 
      mainDocsAllModal, 
      subDocsAllModal,
      mainDocs, 
      subDocs
    } = this.state;

    if (!commit) return <div>Loading...</div>;

    const formatVersion = (version) => {
      if (!version) return '';
      try {
        const date = new Date(version);
        return date.getTime().toString();
      } catch (e) {
        return version;
      }
    };

    return (
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="6">
                    <h4 className="title">Commit Details</h4>
                  </Col>
                  <Col md="6" className="text-right">
                    <Button color="primary" onClick={this.toggleEditModal}>
                      Edit
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row className="mb-4">
                    <Col md="6">
                      <FormGroup>
                        <Label>ID</Label>
                        <div style={{ position: 'relative' }}>
                          <Input 
                            type="text" 
                            value={commit._id} 
                            readOnly 
                            style={{ paddingRight: '40px' }}
                          />
                          <Button 
                            color="link" 
                            onClick={() => this.handleCopy(commit._id, 'ID')}
                            style={{
                              position: 'absolute',
                              right: '5px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              padding: '0.25rem 0.5rem',
                              border: 'none',
                              background: 'transparent'
                            }}
                          >
                            <BsCopy />
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Commit MID</Label>
                        <div style={{ position: 'relative' }}>
                          <Input 
                            type="text" 
                            value={commit.commit_mid} 
                            readOnly 
                            style={{ paddingRight: '40px' }}
                          />
                          <Button 
                            color="link" 
                            onClick={() => this.handleCopy(commit.commit_mid, 'Commit ID')}
                            style={{
                              position: 'absolute',
                              right: '5px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              padding: '0.25rem 0.5rem',
                              border: 'none',
                              background: 'transparent'
                            }}
                          >
                            <BsCopy />
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="mb-4">
                    <Col md="6">
                      <FormGroup>
                        <Label>Title</Label>
                        <div style={{ position: 'relative' }}>
                          <Input 
                            type="text" 
                            value={commit.title} 
                            readOnly 
                            style={{ paddingRight: '40px' }}
                          />
                          <Button 
                            color="link" 
                            onClick={() => this.handleCopy(commit.title, 'Title')}
                            style={{
                              position: 'absolute',
                              right: '5px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              padding: '0.25rem 0.5rem',
                              border: 'none',
                              background: 'transparent'
                            }}
                          >
                            <BsCopy />
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label>Status</Label>
                        <Input type="text" value={commit.status} readOnly />
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label>Created By</Label>
                        <Input type="text" value={commit.created_by} readOnly />
                      </FormGroup>
                    </Col>
                  </Row>

                  <FormGroup className="mb-4">
                    <Label>Commit Message</Label>
                    <div style={{ position: 'relative' }}>
                      <Input 
                        type="textarea" 
                        value={commit.commit_message} 
                        readOnly 
                        style={{ paddingRight: '40px' }}
                      />
                      <Button 
                        color="link" 
                        onClick={() => this.handleCopy(commit.commit_message, 'Commit Message')}
                        style={{
                          position: 'absolute',
                          right: '5px',
                          top: '5px',
                          padding: '0.25rem 0.5rem',
                          border: 'none',
                          background: 'transparent'
                        }}
                      >
                        <BsCopy />
                      </Button>
                    </div>
                  </FormGroup>

                  <Row className="mb-4">
                    <Col md="6">
                      <FormGroup>
                        <Label>Main Documents</Label>
                        <div>
                          <Button color="info" size="sm" className="me-2" onClick={this.toggleMainDocsModal}>
                            View Docs ({commit.main_doc_ids?.length || 0})
                          </Button>
                          <Button color="primary" size="sm" onClick={this.toggleMainDocsAllModal}>
                            View as Conversation ({commit.main_doc_ids?.length || 0})
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Sub Documents</Label>
                        <div>
                          <Button color="info" size="sm" className="me-2" onClick={this.toggleSubDocsModal}>
                            View Docs ({commit.sub_doc_ids?.length || 0})
                          </Button>
                          <Button color="primary" size="sm" onClick={this.toggleSubDocsAllModal}>
                            View as Conversation ({commit.sub_doc_ids?.length || 0})
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="mb-4">
                    <Col md="6">
                      <FormGroup>
                        <Label>Branch ID</Label>
                        <div style={{ position: 'relative' }}>
                          <Input 
                            type="text" 
                            value={commit.branch_id} 
                            readOnly 
                            style={{ paddingRight: '40px' }}
                          />
                          <Button 
                            color="link" 
                            onClick={() => this.handleCopy(commit.branch_id, 'Branch ID')}
                            style={{
                              position: 'absolute',
                              right: '5px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              padding: '0.25rem 0.5rem',
                              border: 'none',
                              background: 'transparent'
                            }}
                          >
                            <BsCopy />
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Parent Branch ID</Label>
                        <div style={{ position: 'relative' }}>
                          <Input 
                            type="text" 
                            value={commit.parent_branch_id} 
                            readOnly 
                            style={{ paddingRight: '40px' }}
                          />
                          <Button 
                            color="link" 
                            onClick={() => this.handleCopy(commit.parent_branch_id, 'Parent Branch ID')}
                            style={{
                              position: 'absolute',
                              right: '5px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              padding: '0.25rem 0.5rem',
                              border: 'none',
                              background: 'transparent'
                            }}
                          >
                            <BsCopy />
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>

                  <FormGroup className="mb-4">
                    <Label>Children Branch IDs</Label>
                    <div style={{ position: 'relative' }}>
                      <Input 
                        type="textarea" 
                        value={JSON.stringify(commit.children_branch_ids)} 
                        readOnly 
                        style={{ paddingRight: '40px' }}
                      />
                      <Button 
                        color="link" 
                        onClick={() => this.handleCopy(JSON.stringify(commit.children_branch_ids), 'Children Branch IDs')}
                        style={{
                          position: 'absolute',
                          right: '5px',
                          top: '5px',
                          padding: '0.25rem 0.5rem',
                          border: 'none',
                          background: 'transparent'
                        }}
                      >
                        <BsCopy />
                      </Button>
                    </div>
                  </FormGroup>

                  <FormGroup className="mb-4">
                    <Label>Checkpoint Data</Label>
                    <div style={{ position: 'relative' }}>
                      <Input 
                        type="textarea" 
                        value={JSON.stringify(commit.checkpoint_data)} 
                        readOnly 
                        style={{ paddingRight: '40px' }}
                      />
                      <Button 
                        color="link" 
                        onClick={() => this.handleCopy(JSON.stringify(commit.checkpoint_data), 'Checkpoint Data')}
                        style={{
                          position: 'absolute',
                          right: '5px',
                          top: '5px',
                          padding: '0.25rem 0.5rem',
                          border: 'none',
                          background: 'transparent'
                        }}
                      >
                        <BsCopy />
                      </Button>
                    </div>
                  </FormGroup>

                  <FormGroup className="mb-4">
                    <Label>Metadata</Label>
                    <div style={{ position: 'relative' }}>
                      <Input 
                        type="textarea" 
                        value={JSON.stringify(commit.metadata)} 
                        readOnly 
                        style={{ paddingRight: '40px' }}
                      />
                      <Button 
                        color="link" 
                        onClick={() => this.handleCopy(JSON.stringify(commit.metadata), 'Metadata')}
                        style={{
                          position: 'absolute',
                          right: '5px',
                          top: '5px',
                          padding: '0.25rem 0.5rem',
                          border: 'none',
                          background: 'transparent'
                        }}
                      >
                        <BsCopy />
                      </Button>
                    </div>
                  </FormGroup>

                  <Row className="mb-4">
                    <Col md="6">
                      <FormGroup>
                        <Label>Version</Label>
                        <Input type="text" value={formatVersion(commit.version)} readOnly />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Friendly Version</Label>
                        <Input type="text" value={commit.friendly_version} readOnly />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="mb-4">
                    <Col md="6">
                      <FormGroup>
                        <Label>Created At</Label>
                        <Input type="text" value={commit.createdAt} readOnly />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Updated At</Label>
                        <Input type="text" value={commit.updatedAt} readOnly />
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <CommitEditModal
          isOpen={editModal}
          toggle={this.toggleEditModal}
          commit={commit}
          onSubmit={this.handleEditSubmit}
        />

        <DocListModal
          isOpen={mainDocsModal}
          toggle={this.toggleMainDocsModal}
          title="Main Documents"
          docs={mainDocs}
        />

        <DocListModal
          isOpen={subDocsModal}
          toggle={this.toggleSubDocsModal}
          title="Sub Documents"
          docs={subDocs}
        />

        <DocListAllModal
          isOpen={mainDocsAllModal}
          toggle={this.toggleMainDocsAllModal}
          title="All Main Documents"
          docs={mainDocs}
        />

        <DocListAllModal
          isOpen={subDocsAllModal}
          toggle={this.toggleSubDocsAllModal}
          title="All Sub Documents"
          docs={subDocs}
        />

        <ToastContainer />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  commit: state.commitReducer.commit
});

export default connect(mapStateToProps, { getCommit, updateCommit })(CommitView); 